<template>
  <div class="lg:hidden space-y-4 max-lg:p-4 max-lg:bg-white max-lg:shadow-top">
    <div class="flex justify-between items-center gap-4">
      <EstimateNightlyRate
        :financial="bookingEstimateData?.Financial"
        show-discount-badge
      />

      <div
        class="text-right lg:hidden"
      >
        <TButton
          variant="link"
         
          @click="emit('expand-details')"
        >
          {{ t('priceDetails') }}
        </TButton>
      </div>
    </div>

    <div>
      <slot name="button" />
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  'expand-details': []
}>()
const { t } = useI18n()

const {
  bookingEstimateData,
} = useBookingEstimate()
</script>

<i18n lang="json">
  {
    "en": {
      "priceDetails": "Price details"
    },
    "fr": {
      "priceDetails": "Détails de prix"

    }
  }
  </i18n>
